import { createApp } from 'vue'
import App from './Faqs.vue'

import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';

import SlideUpDown from 'vue3-slide-up-down';
import { initializePage } from '../../bootstrap/pageBootstrap.js'

// Initialize page bootstrap
initializePage().then((result) => {
  if (!result.success) {
    console.warn('[Faqs] Bootstrap failed:', result.error);
  }
});


let app = createApp(App);

app.use(PrimeVue);
app.component('Dialog', Dialog);
app.component('slide-up-down', SlideUpDown);

app.mount('#app');
